import { NgModule } from '@angular/core';
import { Ga4GgUserLoginEventBuilder } from './ga4-gg-user-login-event.builder';

@NgModule({})
export class Ga4GgUserLoginEventModule {
  constructor(_ga4GgUserLoginEventBuilder: Ga4GgUserLoginEventBuilder) {}
}
